module.exports = __webpack_public_path__ + "img/versatile.87894601.svg";